import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true,
    keepAlive: true,
};

const pre = 'report-';

export default {
    path: '/report',
    name: 'report',
    redirect: {
        name: `${pre}dcps`,
    },
    meta,
    component: BasicLayout,
    children: [
        // 佰业维度
        {
            path: 'dcps',
            name: `${pre}dcps`,
            meta: {
                ...meta,
                title: '佰业维度',
                closable: true
            },
            component: () => import('@/pages/report/dcps')
        },
        // 用户维度
        {
            path: 'user',
            name: `${pre}user`,
            meta: {
                ...meta,
                title: '用户维度',
                closable: true
            },
            component: () => import('@/pages/report/user')
        },
        // 碳减排值
        {
            path: 'carbon',
            name: `${pre}carbon`,
            meta: {
                ...meta,
                title: '碳减排值 - 青岛',
                closable: true,

            },
            component: () => import('@/pages/report/carbon')
        },
        {
            path: 'carbon-sh',
            name: `${pre}carbon-sh`,
            meta: {
                ...meta,
                title: '碳减排值 - 上海',
                closable: true,
            },
            component: () => import('@/pages/report/carbon-sh')
        },
        // 数据盘点
        {
            path: 'inventory',
            name: `${pre}inventory`,
            meta: {
                ...meta,
                title: '数据盘点 - 青岛',
                closable: true,

            },
            component: () => import('@/pages/report/inventory')
        },
        {
            path: 'inventory-sh',
            name: `${pre}inventory-sh`,
            meta: {
                ...meta,
                title: '数据盘点 - 上海',
                closable: true,

            },
            component: () => import('@/pages/report/inventory-sh')
        },
    ]
};
